export default function SiteIntro() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.4fr_1fr]">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-information-line" />
            关于本站
          </span>
          <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            专注忍者世界的动漫资料平台
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            火影忍者动漫频道为动漫爱好者提供系统的剧集剧情介绍、角色资料分析与最新资讯整理。
            无论你是想回顾经典篇章、了解角色背景，还是快速掌握动漫动态，都可以在这里找到清晰、
            完整的参考资料。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            本站所有内容均基于公开信息整理与原创撰写，仅用于动漫文化交流与资料查阅，
            不提供在线观看、下载或任何形式的付费服务。
          </p>
        </div>
        <dl className="grid grid-cols-2 gap-4 self-center">
          {[
            { label: "收录剧集", value: "12+", icon: "ri-film-line" },
            { label: "角色资料", value: "12", icon: "ri-user-line" },
            { label: "资讯动态", value: "8", icon: "ri-newspaper-line" },
            { label: "故事篇章", value: "7", icon: "ri-book-open-line" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="rounded-md border border-background-200 bg-background-50 p-4"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={stat.icon} />
              </span>
              <dt className="mt-3 text-xs text-foreground-500">{stat.label}</dt>
              <dd className="font-heading text-xl font-bold text-foreground-950">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}